import Hero from "@/components/Hero";
import ServicesSection from "@/components/ServicesSection";
import WhyChoose from "@/components/WhyChoose";
import AttorneyPreview from "@/components/AttorneyPreview";
import LatestPosts from "@/components/LatestPosts";
import FAQ from "@/components/FAQ";
import CTABanner from "@/components/CTABanner";
import { useSEO, ORGANIZATION_SCHEMA } from "@/lib/seo";

export default function Home() {
    useSEO({
        title: null,
        description:
            "Chesterton. Counsel for landowners, family businesses, and closely-held enterprises. Estate planning, real estate, and business law.",
        path: "/",
        schema: ORGANIZATION_SCHEMA
    });

    return (
        <>
            <Hero />
            <ServicesSection />
            <WhyChoose />
            <AttorneyPreview />
            <LatestPosts />
            <FAQ />
            <CTABanner />
        </>
    );
}
